<template>
<div class="statistics-index-wrapper">
    <tab :active="1"></tab>
    <!-- 数据 -->
    <div>
        <section>
            <div class="number-info">
                <div class="info-item">
                    <span class="num">{{pvCount}}</span>
                    <br />
                    <span>本月PV</span>
                </div>
                <div class="info-item">
                    <span class="num">{{uvCount}}</span>
                    <br />
                    <span>本月UV</span>
                </div>
            </div>
            <div class="number-info">
                <div class="info-item">
                    <span class="sub-tip">装机量</span>
                    <br />
                    <span class="num">{{installCount}}</span>
                </div>
                <div class="info-item">
                    <span class="sub-tip">覆盖率</span>
                    <br />
                    <span class="num">{{coverage}}%</span>
                </div>
                <div class="info-item">
                    <span class="sub-tip">V{{most.versionName}}</span>
                    <br />
                    <span class="num">{{most.count}}</span>
                </div>
            </div>
        </section>
        <!-- canvas 图表 -->
        <div class="canvas-wrapper">
            <line-canvas></line-canvas>
        </div>
    </div>
</div>
</template>

<script>
import {
    getPvCount,
    getUvCount,
    getUserNum
} from '@/api/statistics'
import tab from './tab'
import lineCanvas from './lineCanvas'
export default {
    components: {
        tab,
        lineCanvas
    },
    computed: {
        coverage() {
            let num = (Number(this.installCount) / Number(this.userCount) * 100).toFixed(2)
            return isNaN(num) ? '' : num;
        }
    },
    data() {
        return {
            installCount: '--',
            userCount: '--',
            most: {
                versionName: '--',
                count: '--'
            },
            pvCount: '--',
            uvCount: '--',
            startTime: null,
            endTime: null
        }
    },
    created() {
        this.fetchUserNum();
    },
    methods: {

        // 获取用户装机量
        fetchUserNum() {
            getUserNum().then(({
                data
            }) => {
                if (data.code === 200) {
                    this.installCount = data.data.installCount;
                    this.installCount = data.data.installCount;
                    this.userCount = data.data.userCount;
                    this.most = data.data.most;
                    this.pvCount = data.data.pvCount;
                    this.uvCount = data.data.uvCount;
                }
            }).finally(data => {
                data = {
                    "code": 200,
                    "data": {
                        "installCount": 78,
                        "most": {
                            "count": 64,
                            "versionName": "1.9.0"
                        },
                        "pvCount": 6851,
                        "userCount": 5500,
                        "uvCount": 11
                    },
                    "success": true
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.statistics-index-wrapper {
    padding: 20px;

    .number-info {
        margin-bottom: 20px;
        padding-bottom: 15px;
        font-size: 14px;
        border-bottom: 1px solid #eee;
        display: flex;
        text-align: center;
        &:first-child{
            margin-top: 30px;
        }
        &:last-child{
            margin-bottom: 30px;
        }
        .num{
            font-weight: bold;
            font-size: 14px;
        }
    }

    .info-item {
        padding: 0 30px;
        flex: 1;
        .sub-tip{
            color: #999;
            font-size: 12px;
        }
    }
}
</style>
